export enum Languages {
  en = 'en',
  es = 'es',
}
